import { render, staticRenderFns } from "./TableView.vue?vue&type=template&id=6bb11b2e&scoped=true&"
import script from "./TableView.vue?vue&type=script&lang=js&"
export * from "./TableView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb11b2e",
  null
  
)

export default component.exports